import React, { useEffect, useState } from 'react';

// Claro ou escuro nos painéis internos (Comando, painel da equipe, Desk). A escolha fica neste navegador e vale para os três.
// Cada página tem um tema "de nascença"; quando a pessoa escolhe o outro, a página inteira é invertida (com o matiz preservado),
// e fotos, vídeos e o que tiver a classe tmr-keep voltam ao normal.
const KEY = 'tmr_theme';
const CSS = 'html.tmr-flip{filter:invert(1) hue-rotate(180deg)}'
  + 'html.tmr-flip img:not(.tmr-logo),html.tmr-flip video,html.tmr-flip .tmr-keep{filter:invert(1) hue-rotate(180deg)}'
  + 'html.tmr-flip .tmr-keep img.tmr-logo{filter:brightness(0) invert(1)}';

const read = () => {
  try { const v = localStorage.getItem(KEY); return v === 'dark' || v === 'light' ? v : ''; } catch (e) { return ''; }
};

export const useTheme = (native, nativeBg) => {
  const [theme, setTheme] = useState(() => read() || native);
  useEffect(() => {
    if (!document.getElementById('tmr-theme-css')) {
      const st = document.createElement('style');
      st.id = 'tmr-theme-css';
      st.textContent = CSS;
      document.head.appendChild(st);
    }
    const root = document.documentElement;
    const flip = theme !== native;
    root.classList.toggle('tmr-flip', flip);
    const prevBg = root.style.backgroundColor;
    if (flip) root.style.backgroundColor = nativeBg;
    return () => { root.classList.remove('tmr-flip'); root.style.backgroundColor = prevBg; };
  }, [theme, native, nativeBg]);
  const toggle = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    try { localStorage.setItem(KEY, next); } catch (e) { /* storage blocked */ }
    setTheme(next);
  };
  return [theme, toggle];
};

export const ThemeButton = ({ theme, onToggle, className = '' }) => (
  <button type="button" onClick={onToggle} title="Trocar entre claro e escuro" className={className}>
    {theme === 'dark' ? '☀️ Claro' : '🌙 Escuro'}
  </button>
);
